import React from 'react';
import { motion } from 'framer-motion';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

interface FeatureNotFoundMessageProps {
  featureKey: string;
}

/**
 * Message component shown when a feature flag doesn't exist in the database
 * Helps identify configuration issues or typos in feature keys
 */
export const FeatureNotFoundMessage: React.FC<FeatureNotFoundMessageProps> = ({
  featureKey
}) => {
  return (
    <div className="flex items-center justify-center min-h-[400px] p-8">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.4 }}
        className="bg-white/5 backdrop-blur-sm border border-white/20 rounded-xl p-8 max-w-md text-center"
      >
        <div className="w-16 h-16 mx-auto mb-4 bg-orange-500/20 rounded-full flex items-center justify-center">
          <ExclamationTriangleIcon className="w-8 h-8 text-orange-400" />
        </div>
        
        <h3 className="text-2xl font-bold text-white mb-2">
          Feature Not Found
        </h3>
        
        <p className="text-white/70 mb-2">
          The feature <code className="px-2 py-1 bg-white/10 rounded text-sm">{featureKey}</code> doesn't exist.
        </p>
        
        <p className="text-white/50 text-sm">
          This may be a configuration issue. Please contact support if the problem persists.
        </p>
      </motion.div>
    </div>
  );
};

export default FeatureNotFoundMessage;
